import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useTranslation } from "react-i18next";

import SideMenu from "./SideMenu";

const drawerWidth = 240;

function ResponsiveDrawer(props) {

  const { window, element, title, onLogout, language,
    onLanguageChange, hiddenPages, facilities, selectedFacility, onFacilityChange, onSelectPortfolioView, hideMenu } = props;

  const isPortfolioView = props.portfolioView === true;

  const { t } = useTranslation();

  const [mobileOpen, setMobileOpen] = React.useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClickFacilityMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseFacilityMenu = () => {
    setAnchorEl(null);
  };
  const handleSelectFacility = (val) => {
    onFacilityChange(val);
    setAnchorEl(null);
  };
  const handleSelectPortfolioView = () => {
    onSelectPortfolioView();
    setAnchorEl(null);
  };


  React.useEffect(() => {
    setMobileOpen(false);
  },
    [element]
  );

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = <SideMenu onLanguageChange={onLanguageChange} onLogout={onLogout} hiddenPages={hiddenPages} language={language} />

  const container = window !== undefined ? () => window().document.body : undefined;


  return (
    <React.Fragment >
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
      >
        <Toolbar style={{ backgroundColor: "#175BFF", color: 'white' }}>
          {!hideMenu && (
            <>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ mr: 2, display: { sm: 'none' } }}
              >
                <MenuIcon />
              </IconButton>
              <Button
                onClick={handleClickFacilityMenu}
                sx={{ textTransform: 'none' }}
                variant="contained"
                disableElevation
                endIcon={<ArrowDropDownIcon />}
              >
                <Typography variant="h6" color="white" >
                  {isPortfolioView ? t("All facilities") : facilities.filter((f) => f.url === selectedFacility)[0]?.name}
                </Typography>
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleCloseFacilityMenu}
              >
                {
                  isPortfolioView && (facilities.length > 1) && <MenuItem key="**all_facilities**" onClick={handleSelectPortfolioView}>{t("All facilities")}</MenuItem>
                }
                {
                  facilities.map((f) => <MenuItem key={f.url} onClick={() => handleSelectFacility(f.url)}>{f.name}</MenuItem>)
                }
              </Menu>
              <Typography variant="h6" noWrap component="div" marginLeft={1} marginRight={2}>
                {"/"}
              </Typography>
            </>
          )}
          <Typography variant="h6" noWrap component="div">
            {title}
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="navigation menu"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{ width: { sm: `calc(100% - ${drawerWidth}px)` }, marginLeft: { sm: drawerWidth + "px" } }}
      >
        <Toolbar />
        {element}
      </Box>
    </React.Fragment>
  );
}

export default ResponsiveDrawer;
